import { Component, OnInit, OnDestroy, OnChanges, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/services/api.service';
import { DataShareService } from 'app/services/data-share.service';
import { UserStorageService } from 'app/services/user-storage.service';
import { UserSessionService } from 'app/services/user-session.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { Observable } from 'rxjs/'
import { from } from 'rxjs/observable/from';
import { switchMap, tap, debounceTime, distinctUntilChanged, catchError } from 'rxjs/operators'
import { DataService } from 'app/services/data-service'
import { environment } from 'environments/environment';
import { Solicitacao } from 'app/models/Solicitacao';
import { Agente } from 'app/models/agente';
import { Unidades } from 'app/models/Unidades';
import { AlertaPanico } from 'app/services/alertaPanico.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit, OnDestroy, OnChanges {

    private readonly supervisorSuperior: number = 9
    //Propriedades
    public url: string;
    public title: string;
    public typeView: string;
    public user: string;
    public usuario: any;
    public myRole: any;
    public solicitacaoPesquisada: string;
    objeto;
    @Output() objetoAchado = new EventEmitter();
    searchForm: FormGroup;
    searchControl: FormControl;
    markerClicked: Solicitacao;
    formularioLateral = false;
    visibleButton: boolean = false;
    butonRelatorio: boolean = false;

    //Construtor
    constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute,
        private apiservice: ApiService, private userService: UserStorageService,
        private userSession: UserSessionService, private dataService: DataShareService,
        private data: DataService, private alertaPanico: AlertaPanico) { }

    //Métodos
    ngOnInit(): void {
        // this.typeView = 'Monitor'
        this.typeView = 'Mapa'
        //throw new Error("Method not implemented.");
        //console.log("Method NavbarComponent ngOnInit.");
        this.title = "Bem Vindo a Versão Beta do Novo Portal";//this.dataService.get(KEY_SERVICE.TITLE_KEY);
        this.searchControl = this.fb.control('')
        this.searchForm = this.fb.group({
            searchControl: this.searchControl
        })

        this.usuario = this.userService.getUser();

        this.butonRelatorio = this.usuario.roles.some(r => r.id === this.supervisorSuperior);
        this.visibleButton = this.usuario.roles.some(r => r.name === 'admin' || r.name === 'Gestor');
    }

    emitirEvento(dado) {
        this.objetoAchado.emit(dado)
    }

    ngOnDestroy() {
        //console.log("Method NavbarComponent ngOnDestroy.");
        //this.title = null;
        //this.dataService.remove(KEY_SERVICE.TITLE_KEY);
    }

    ngOnChanges() {
        //console.log("Method NavbarComponent ngOnChanges.");
        //this.title = this.dataService.get(KEY_SERVICE.TITLE_KEY);
    }

    onLogout() {
        /*
        let tokenLaravel = this.userSession.get();
        this.apiservice.post("auth/logout",{'token' : tokenLaravel}, this.apiservice.getHostLaravel())
        .subscribe(
            function (data){
                //console.log('webserve laravel kid logout: ',data);
            },
            function(error){
                //console.log('webserve laravel kid error logout: ',error);
            }
        )
        */
        this.userService.removeUser();
        this.userSession.deleteToken();
        this.router.navigate(['/login']);
    }

    onProfile() {
        if (this.router.navigate(['/profile'])) {
            this.data.alterarStatusSideBarIsOpen(false);
        }
    }
    onUsuarios() {
        if (this.router.navigate(['/usuarios'])) {
            this.data.alterarStatusSideBarIsOpen(false);
        }
    }

    exibirRelatorios() {
        if (this.router.navigate(['usuarios/relatorios'])) {
            this.data.alterarStatusSideBarIsOpen(false);
        }
    }

  //   exibirTros() {
  //     if (this.router.navigate(['tros/relatorios'])) {
  //         this.data.alterarStatusSideBarIsOpen(false);
  //     }
  // }
    // changueTypeView(){
    //     if(this.router.navigate(['/mapa'])){
    //         this.data.alterarStatusSideBarIsOpen(true);
    //     }
    //     if(this.typeView == 'Mapa'){
    //         this.typeView = 'Monitor';
    //         this.data.sendMessage('typeViewMapa');
    //     } else {
    //         this.typeView = 'Mapa';
    //         this.data.sendMessage('typeViewMonitor');
    //     }

    // }

    changueTypeView() {
        if (this.router.navigate(['/'])) {
            this.data.alterarStatusSideBarIsOpen(true);
        }
    }

    stopAudioPanico(){
      this.alertaPanico.stop();
    }

    get audioPanicoAtivo(): boolean {
      return AlertaPanico.audioAtivo;
    }
}

export const KEY_SERVICE = { TITLE_KEY: "titleNavBar" };



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts